<template>
	<div>
		<ListHeaderComponent :background="background">
			<span slot="title">{{title}}</span>
		</ListHeaderComponent>
		<EventHeaderComponent :id="judgeID"></EventHeaderComponent>
		<DetailsComponent @getJudgeID="getID"></DetailsComponent>
		<ContactComponent></ContactComponent>
		<PartnersComponent></PartnersComponent>
	</div>
</template>

<script>
	import ListHeaderComponent from '@/components/ListHeaderComponent'
	import EventHeaderComponent from '@/components/Judge/EventHeaderComponent'
	import DetailsComponent from '@/components/Judge/DetailsComponent'
	import ContactComponent from '@/components/ContactComponent'
	import PartnersComponent from '@/components/PartnersComponent'

	export default {
		components: {
			ListHeaderComponent,
			EventHeaderComponent,
			DetailsComponent,
			ContactComponent,
			PartnersComponent
		},
		data () {
			return {
				title: this.$t('judges.header'),
				background: 'judges',
				judgeID: ''
			}
		},
		methods: {
			getID (id) {
				this.judgeID = id
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Judge.vue